import React, { useEffect } from 'react';
// eslint-disable-next-line no-unused-vars
import { makeStyles, TextField, TextFieldProps } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: 200,
        [theme.breakpoints.down(1025)]: {
            width: 'unset'
        }
    },
    title: {
        fontFamily: 'mainFont',
        fontSize: 14,
        padding: '0px 5px',
        textAlign: 'justify'
    },
    inputContainer: ({ isNewFactor }) => ({
        display: 'flex',
        alignItems: 'stretch',
        // background: contentEditable ? '#ecf4ff' : 'white',
        background: '#fff',
        // borderRadius: 4,
        height: 40,
        // border: 'unset !important',
        justifyContent: 'center',
        borderRadius: isNewFactor ? 4 : !isNewFactor ? 'unset' : 6,
        border: isNewFactor ? '1px solid #ced2d6 !important' : 'unset !important',
        borderBottom: !isNewFactor ? '1px solid #ced2d6 !important' : isNewFactor && '',
        '&:focus-within': {
            background: 'white',
            // border: '1.5px solid #1b90fa !important',
            border: isNewFactor ? '1.5px solid #1b90fa !important' : 'unset !important',
            borderBottom: !isNewFactor && '1.5px solid #1b90fa !important',
            [theme.breakpoints.down(1025)]: {}
        },
        [theme.breakpoints.down(1025)]: {
            background: '#fff'
        }
    }),
    input: ({ contentEditable }) => ({
        display: 'flex',
        alignItems: 'center',
        padding: '0px 10px',
        height: '100%',
        color: !contentEditable ? '#3d454a' : undefined
    })
}));

/**
 * @param {TextFieldProps & {className: string,label: string,contentEditable: boolean}} props
 */
export default function TextInput({
    className,
    label,
    isNewFactor,
    customClasses,
    isNumber = false,
    contentEditable = true,
    ...props
}) {
    const classes = useStyles({ contentEditable, isNewFactor });

    const textFieldRef = React.useRef(null);

    useEffect(() => {
        const handleWheel = (e) => e.preventDefault();
        textFieldRef.current.addEventListener('wheel', handleWheel);

        return () => {
            textFieldRef.current.removeEventListener('wheel', handleWheel);
        };
    }, []);

    return (
        <div className={`${classes.container} ${className}`}>
            <label className={customClasses?.title || classes.title}>{label}</label>
            <TextField
                {...props}
                type={isNumber ? 'number' : 'text'}
                className={customClasses?.input || classes.inputContainer}
                inputProps={{ className: classes.input, 'data-testid': `${props.name}` }}
                disabled={!contentEditable}
                autoComplete="off"
                ref={textFieldRef}
            />
        </div>
    );
}
TextInput.propTypes = {
    className: PropTypes.any,
    label: PropTypes.string,
    contentEditable: PropTypes.any,
    isNewFactor: PropTypes.bool,
    name: PropTypes.string,
    customClasses: PropTypes.any,
    isNumber: PropTypes.bool
};
